import './legacy/mutators';
export { default as DiagnosticsPanel } from './legacy/components/DiagnosticsPanel';
export { default as registerDiagnostics } from './legacy/actions/registerDiagnostics';
export { default as setSelectedPivot } from './legacy/mutators/setSelectedPivot';
export { default as initializeDefaultDiagnostics } from './legacy/initializeDefaultDiagnostics';
export { getDiagnosticsLogState } from './legacy/store/store';

export { DiagnosticsHost } from './components/DiagnosticsHost';
export { DiagnosticsInspector } from './components/DiagnosticsInspector';
export { TwoColumnInspector } from './components/TwoColumnInspector';
